<template>
  <div>
    <v-flex xs12>
      <h2 class="text-center mb-3">Rydding og rengjøring</h2>
    </v-flex>
    <v-flex xs12 class="mb-2">
      <BooleanInput v-model="stepValues.bool" @update-fields="updateFields"></BooleanInput>
    </v-flex>
    <template v-if="!stepValues.bool.cleaningOk.value">
      <v-flex xs12 class="mb-3">
        <v-flex v-if="stepValues.relatedComment" xs12 class="m-4" style="border: 1px dashed orange">
          <span><strong>Kommentar fra innflytting:</strong> {{stepValues.relatedComment}}</span>
        </v-flex>
        <v-textarea box v-model="stepValues.comment" @input="updateFields" label="Krav til utbedring"></v-textarea>
      </v-flex>
      <v-flex xs12 class="mb-3">
        <v-flex v-if="stepValues.relatedPrice" xs12 class="m-4" style="border: 1px dashed orange">
          <span><strong>Pris/kompensasjon fra innflytting:</strong> {{stepValues.relatedPrice}}</span>
        </v-flex>
        <v-text-field label="Pris/kompensasjon" v-model="stepValues.price"></v-text-field>
      </v-flex>
      <ImageUploadBox :images="stepValues.images" :relatedImages="stepValues.relatedImages"></ImageUploadBox>
    </template>
    <StepButtons @next-page="next" @previous-page="previous" :step="this" />
  </div>
</template>

<script>
import step from "../../mixins/step";

export default {
  mixins: [step],
  mounted: function() {
    if(this.protocol.related_protocol) {
      if(this.protocol.related_protocol.steps.cleaning.saved_values.bool && !this.protocol.related_protocol.steps.cleaning.saved_values.loadedFromRelated) {
        this.protocol.related_protocol.steps.cleaning.saved_values.loadedFromRelated = true
        let values = JSON.parse( JSON.stringify(this.protocol.related_protocol.steps.cleaning.saved_values))
        this.stepValues.relatedImages = values.images
        this.stepValues.relatedComment = values.comment
        this.stepValues.relatedPrice = values.price
      }
    }
  }
};
</script>
